(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zf-batch-main"]) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.zfReady) return;
      root.dataset.zfReady = '1';
      var btn = root.querySelector('[data-zf-add]');
      var priceEl = root.querySelector('[data-zf-price]');
      var msg = root.querySelector('.zf-batch__msg');
      root.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio' && e.target.dataset.price) priceEl.textContent = e.target.dataset.price;
      });
      btn.addEventListener('click', function () {
        var picked = root.querySelector('input[type="radio"]:checked');
        if (!picked) { msg.hidden = false; msg.textContent = 'Choose a bottle size.'; return; }
        btn.setAttribute('aria-busy', 'true');
        msg.hidden = true;
        var body = { items: [{ id: Number(picked.value), quantity: 1, properties: { Batch: root.dataset.batch, _Reorder: 'true' } }] };
        fetch(root.dataset.addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to cart.');
            window.location.href = root.dataset.cartUrl;
          })
          .catch(function (err) {
            btn.removeAttribute('aria-busy');
            msg.hidden = false;
            msg.textContent = err && err.message ? err.message : 'Could not add to cart. Please try again.';
          });
      });
    }
    function boot() { document.querySelectorAll('[data-zf-reorder]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zf-find-a-blend"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(lib) {
      if (lib.dataset.zfReady) return;
      lib.dataset.zfReady = '1';
      var params = new URLSearchParams(window.location.search);
      var cards = Array.prototype.slice.call(lib.querySelectorAll('.zf-find__card'));
      var selects = lib.querySelectorAll('[data-zf-filter]');
      selects.forEach(function (sel) {
        var key = sel.dataset.zfFilter, seen = {}, vals = [];
        cards.forEach(function (c) { var v = c.dataset[key]; if (v && !seen[v.toLowerCase()]) { seen[v.toLowerCase()] = 1; vals.push(v); } });
        var want = params.get(key) || '';
        if (want && !seen[want.toLowerCase()]) vals.push(want);
        vals.sort();
        vals.forEach(function (v) { var o = document.createElement('option'); o.value = v; o.textContent = v; sel.appendChild(o); });
        sel.value = want;
        if (sel.value !== want) sel.value = '';
      });
      function apply() {
        var shown = 0, active = false;
        cards.forEach(function (c) {
          var ok = true;
          selects.forEach(function (sel) { if (sel.value) { active = true; if ((c.dataset[sel.dataset.zfFilter] || '').toLowerCase() !== sel.value.toLowerCase()) ok = false; } });
          c.hidden = !ok; if (ok) shown++;
        });
        var count = lib.querySelector('[data-zf-count]'), empty = lib.querySelector('[data-zf-empty]');
        count.hidden = !active; count.textContent = shown + ' of ' + cards.length + ' blends on this page';
        empty.hidden = shown > 0;
      }
      selects.forEach(function (sel) { sel.addEventListener('change', apply); });
      var form = lib.querySelector('[data-zf-controls]');
      var FK = ['style', 'sweetness', 'strength'];
      // carry active filters through the pager links
      lib.querySelectorAll('a.zf-find__pg').forEach(function (a) {
        var u = new URL(a.getAttribute('href'), window.location.origin);
        FK.forEach(function (k) { if (params.get(k)) u.searchParams.set(k, params.get(k)); });
        a.setAttribute('href', u.pathname + u.search);
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var p = new URLSearchParams();
        if (form.elements.sort.value === 'oldest') p.set('view', 'oldest');
        FK.forEach(function (k) { if (form.elements[k].value) p.set(k, form.elements[k].value); });
        var qs = p.toString();
        window.location.href = window.location.pathname + (qs ? '?' + qs : '');
      });
      // Newest first is the default: land on the last stored page unless a page was asked for
      var pages = parseInt(lib.dataset.pages, 10) || 1;
      if (lib.dataset.oldest !== 'true' && pages > 1 && !params.has(lib.dataset.pp)) {
        params.set(lib.dataset.pp, String(pages));
        window.location.replace(window.location.pathname + '?' + params.toString());
        return;
      }
      apply();
    }
    function boot() { document.querySelectorAll('[data-zf-library]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
